import React, { useContext, useState } from "react";
import { Box, Container } from "@mui/material";
import AddPaymentMethod from "../../common/screen/AddPaymentMethod";
import TouchAmountEntry from "../component/TouchAmountEntry";
import { UserContext } from "../../context/UserContext";

export default function QuickCharge(props) {
  const { user } = useContext(UserContext);

  const [payment, setPayment] = useState({
    amount: "",
    includeFees: user.config?.transferFees === "false" ? false : true,
    total: "",
  });

  return (
    <Container maxWidth="sm" disableGutters>
      <Box>
        <Box mb={2}>
          <TouchAmountEntry payment={payment} onChange={(val) => setPayment(val)} />
        </Box>
        <AddPaymentMethod
          items={[
            {
              type: "Other",
              images: [],
              title: "Quick Sale",
              price: payment.amount,
              quantity: "1",
              includeFees: payment.includeFees,
              total: payment.total,
            },
          ]}
          disabled={+payment.amount === 0}
          returnUrl={`/quick-charge`}
        />
      </Box>
    </Container>
  );
}
